import React from 'react'
import maskBackgroundImage from './images/bg-wx-mask.png'
import './browser-mask.scss'

function BrowserMask({ isVisible, onClose }) {
  if (!isVisible) {
    return null
  }

  const handleMaskClick = () => {
    onClose?.()
  }

  return (
    <div
      className="browser-mask"
      role="presentation"
      style={{ backgroundImage: `url(${maskBackgroundImage})` }}
      onClick={handleMaskClick}
    />
  )
}

export default BrowserMask
